/* 27.10.2026 (Яна): короткий опис у картці товару показуємо повністю до 10 рядків, «Show More» лише для довших */
var AP_DESC_LINES = 10;
function getToggleStrings() {
  return window.translations || {
    showMore: "Show More",
    showLess: "Show Less",
  };
}

function toggleTextDesc() {
  let e = document.getElementById("descriptionTextDesc"),
  t = document.getElementById("showMoreBtnDesc");
  const strings = getToggleStrings();
  if (!e || !t) return;
  if (e.classList.contains("expanded")) {
    let n = parseFloat(window.getComputedStyle(e).lineHeight);
    (e.style.maxHeight = `${AP_DESC_LINES * n}px`),
      e.classList.remove("expanded"),
      (t.textContent = strings.showMore);
  } else
    e.classList.add("expanded"),
      (e.style.maxHeight = "100%"),
      (t.textContent = strings.showLess);
}
function toggleText() {
  let e = document.getElementById("descriptionText"),
    t = document.getElementById("showMoreBtn");
  const strings = getToggleStrings();
  if (!e || !t) return;
  if (e.classList.contains("expanded")) {
    let n = parseFloat(window.getComputedStyle(e).lineHeight);
    (e.style.maxHeight = `${AP_DESC_LINES * n}px`),
      e.classList.remove("expanded"),
      (t.textContent = strings.showMore);
  } else
    e.classList.add("expanded"),
      (e.style.maxHeight = "100%"),
      (t.textContent = strings.showLess);
}
/* Прибирає порожній «хвіст» опису (<p><br><br>…</p>, порожні <p>/<div>, кінцеві <br>, &nbsp;),
   який редактор Shopify лишає в кінці тексту. Інакше після «Show More» під текстом
   з'являється дірка висотою в ці порожні рядки (Яна, 26.10.2026). */
function trimDescriptionTail(elementId) {
  const el = document.getElementById(elementId);
  if (!el) return;
  const isBlank = (node) => {
    if (node.nodeType === 3) return !node.textContent.replace(/\u00a0/g, " ").trim();
    if (node.nodeType !== 1) return true;
    if (node.tagName === "BR") return true;
    if (node.querySelector("img,video,iframe,table,ul,ol,a,strong,em,b,i,span")) {
      return !node.textContent.replace(/\u00a0/g, " ").trim() && !node.querySelector("img,video,iframe,table");
    }
    return !node.textContent.replace(/\u00a0/g, " ").trim();
  };
  let guard = 0;
  while (el.lastChild && isBlank(el.lastChild) && guard++ < 50) el.removeChild(el.lastChild);
  // кінцеві <br> усередині останнього абзацу
  const last = el.lastElementChild;
  if (last) {
    let g = 0;
    while (last.lastChild && isBlank(last.lastChild) && g++ < 50) last.removeChild(last.lastChild);
  }
}
function checkTextOverflow(elementId, buttonId) {
  let e = document.getElementById(elementId),
    t = document.getElementById(buttonId);
  if (!e) {
    return;
  }

  if (!t) {
    return;
  }
  let lineHeight = parseFloat(window.getComputedStyle(e).lineHeight);
  let maxHeight = AP_DESC_LINES * lineHeight;

  e.style.maxHeight = `${maxHeight}px`;

  if (e.scrollHeight <= maxHeight) {
    t.style.display = "none";
  }
}
document.addEventListener("DOMContentLoaded", () => {
  let e = document.querySelectorAll(".faq-toggle");
  e.forEach((e) => {
    e.addEventListener("click", () => {
      let t = e.closest(".grid__single-product-faq-qa");
      document
        .querySelectorAll(".grid__single-product-faq-qa.active")
        .forEach((e) => {
          e !== t && e.classList.remove("active");
        }),
        t.classList.toggle("active");
    });
  });
}),
  document.addEventListener("DOMContentLoaded", function () {
    trimDescriptionTail("descriptionTextDesc");
    trimDescriptionTail("descriptionText");
    checkTextOverflow("descriptionTextDesc", "showMoreBtnDesc");
    checkTextOverflow("descriptionText", "showMoreBtn");
  }),
  document.addEventListener("DOMContentLoaded", function () {
    const descriptionTextDesc = document.getElementById("descriptionTextDesc");
    const showMoreBtnDesc = document.getElementById("showMoreBtnDesc");

    if (descriptionTextDesc && showMoreBtnDesc) {
      const lineHeight = parseFloat(
        window.getComputedStyle(descriptionTextDesc).lineHeight
      );
      const maxHeight = AP_DESC_LINES * lineHeight;

      if (descriptionTextDesc.scrollHeight > maxHeight) {
        descriptionTextDesc.style.maxHeight = `${maxHeight}px`;
        descriptionTextDesc.classList.add("text-container");
        showMoreBtnDesc.style.display = "inline";
      }
    }
    const scrollToDescriptionBtn = document.getElementById(
      "scrollToDescription"
    );
    const descriptionSection = document.getElementById("description-section");

    if (scrollToDescriptionBtn && descriptionSection) {
      $("#scrollToDescription").on("click", function (e) {
        e.preventDefault();
        const offsetTop =
          descriptionSection.offsetTop + descriptionSection.offsetHeight;
        $("html, body").animate({ scrollTop: offsetTop }, 1000);
      });
    }

    const toAnimateElements = document.querySelectorAll(".to-animate");

    if (toAnimateElements.length > 0) {
      function handleScroll() {
        const windowHeight = window.innerHeight;
        toAnimateElements.forEach((el) => {
          const rectTop = el.getBoundingClientRect().top;
          if (rectTop < windowHeight && rectTop > 0) {
            el.classList.add("visible");
          }
        });
      }

      window.addEventListener("scroll", handleScroll);
      handleScroll();
    }
  }),
  document.addEventListener("DOMContentLoaded", function () {
    const descriptionText = document.getElementById("descriptionText");
    const showMoreBtn = document.getElementById("showMoreBtn");

    if (descriptionText && showMoreBtn) {
      try {
        const lineHeight = parseFloat(
          window.getComputedStyle(descriptionText).lineHeight
        );
        const maxHeight = AP_DESC_LINES * lineHeight;

        if (descriptionText.scrollHeight > maxHeight) {
          descriptionText.style.maxHeight = `${maxHeight}px`;
          descriptionText.classList.add("text-container");
          showMoreBtn.style.display = "inline";
        }
      } catch (error) { }
    }
  }),
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (e) {
      if (
        location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var t = $(this.hash);
        (t = t.length ? t : $("[name=" + this.hash.slice(1) + "]")).length &&
          (e.preventDefault(),
            $("html, body").animate(
              { scrollTop: t.offset().top - 100 },
              1e3,
              function () {
                var e = $(t);
                if ((e.focus(), e.is(":focus"))) return !1;
                e.attr("tabindex", "-1"), e.focus();
              }
            ));
      }
    });
